module.exports = __webpack_public_path__ + "img/year.30c17c1f.svg";